import { observable, computed, makeObservable } from "mobx";
import PatientStore from "../Patients/PatientStore";
import { MODULE_ID } from "../../shared/moduleIds";
import { patientSort } from "../Patients/PatientSort";
import _ from "lodash";
import config from "../../config";

export default class ObSurveilStore extends PatientStore {
  _layout =
    this.prefs?.userPreferences?.client?.ob?.multiPatient?.layout || "4";
  obPatients = [];
  _selectedPatient;
  showPatientList;
  showPHI = false;
  customSortedPatients;
  isSurveil = true;

  constructor({ listIndex, appStore }) {
    super({ listIndex, appStore });

    makeObservable(this, {
      _layout: observable,
      obPatients: observable,
      _selectedPatient: observable,
      showPatientList: observable,
      showPHI: observable,
      customSortedPatients: observable,
      visibleObPatientsByLayout: computed,
    });

    this.appStore = appStore;
    this.loadPrefs();
  }

  async loadPrefs() {
    this.showPHI = await this.appStore.getPref("pm.showPHI");
  }

  togglePHI() {
    if (config.hidePHI) {
      this.showPHI = false;
      return;
    }
    this.showPHI = !this.showPHI;
    this.appStore.setPref("pm.showPHI", this.showPHI);
  }

  /****************************************************************************/
  // TODO: make a surveilStore superclass, and extend PmSurveilStore, and OBSurveilStore from that.
  get patients() {
    if (this.customSortedPatients) {
      return this.filterPatients(this.customSortedPatients);
    }
    let patients = this._patients;
    patients = this.filterPatients(patients);
    patients = this.sortPatients(patients);

    return patients;
  }
  set patients(patients) {
    this._patients = patients;
  }

  async getPatients() {
    await super.getPatients(...arguments);
    // New array of patients from getPatients
    let freshPatients = this.patients;

    if (this.customSortedPatients?.length) {
      const patients = this.customSortedPatients
        .map((patient) =>
          freshPatients.find(
            (newPatient) => newPatient.asmpid === patient.asmpid,
          ),
        )
        .filter(Boolean);

      const newPatients = this.isMyPatients
        ? []
        : freshPatients.filter(
            (newPatient) =>
              !this.customSortedPatients.find(
                (oldPatient) => oldPatient.asmpid === newPatient.asmpid,
              ),
          );

      // Add the new patients to the end of the list
      const finalPatients = patients.concat(newPatients);
      this.patients = finalPatients;
    }
  }

  customSorts = [];
  listChange(list) {
    this.customSorts[this.listIndex] = this.customSortedPatients;
    this.customSortedPatients = this.customSorts[this.lists.indexOf(list)];
    this.resetCustomSort();
    super.listChange(...arguments);
  }

  sortPatients(patients) {
    let sorted = super.sortPatients(patients);
    const groupBy = this.groupByValue?.value;
    if (this.isCustomBedList) return sorted;
    if (groupBy) {
      sorted = patientSort(
        sorted,
        groupBy,
        this.selectedListOption,
        this.groupByInverted,
      );
    }
    return sorted;
  }
  get groupSortActive() {
    return (
      !_.isEqual(_.pickBy(this.groupSort, Boolean), this.defaultGroupSort()) &&
      !this.customSortedPatients
    );
  }
  resetCustomSort() {
    this.customSortedPatients = undefined;
  }
  inverter(...args) {
    return (...inverted) => {
      super.inverter(...args)(...inverted);
      this.resetCustomSort();
    };
  }
  updateSelect(...args) {
    return (...selectArgs) => {
      super.updateSelect(...args)(...selectArgs);
      this.resetCustomSort();
    };
  }
  get simpleSearchEnabled() {
    return false;
  }
  // TODO: use an observer to reset custom sort
  resetGroupSort() {
    super.resetGroupSort();
    this.resetCustomSort();
  }

  // *************************************************  end TODO: move to superclass

  get visibleObPatientsByLayout() {
    return this.patients.slice(0, this.layout);
  }

  get layout() {
    return this._layout;
  }

  set layout(value) {
    this._layout = value;
    this.appStore.setPref("ob.multiPatient.layout", value);
  }

  get groupSortDisabled() {
    return false;
  }

  get unitFilterEnabled() {
    return !this.isMyPatients;
  }

  get selectedPatient() {
    return this._selectedPatient;
  }
  set selectedPatient(value) {
    this._selectedPatient = value;
  }

  get sortableLists() {
    return this.lists.filter((list) => list.moduleId === MODULE_ID.OBSTETRICS);
  }

  get hiddenUnits() {
    return super.hiddenUnits;
  }

  set hiddenUnits(hiddenUnits) {
    this.resetCustomSort();
    super.hiddenUnits = hiddenUnits;
  }
}
